<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

        <v-container fluid>
            <v-row>
                <v-col>
                    <v-card class="elevation-6">
                        <v-card-text>
                            <p class="title text--primary ml-3">
                                Πληρωμές</p>
                        </v-card-text>

                        <v-divider></v-divider>

                        <!--                        <v-row>-->
                        <!--                            <v-col class="mx-5">-->
                        <!--                                <v-card class="elevation-0" overlined>-->
                        <!--                                    <p class="subtitle-1 text&#45;&#45;primary ml-3">-->
                        <!--                                        Σύστημα Πληρωμών για τις διανομές μέχρι και το Ακαδημαϊκό Έτος 2015 - 16</p>-->
                        <!--                                    <v-divider></v-divider>-->

                        <!--                                    <p class="subtitle-2 text&#45;&#45;primary ml-3 mt-5">-->
                        <!--                                        Για την διαχείριση των καταστάσεων πληρωμών που αφορούν σε διανομές μέχρι και το ακαδημαϊκό έτος-->
                        <!--                                    2015-16, πατήστε το κουμπί για να οδηγηθείτε στο σύστημα πληρωμών:</p>-->

                        <!--&lt;!&ndash;                                    <p class="subtitle-2 text&#45;&#45;primary ml-3 mt-5">&ndash;&gt;-->
                        <!--&lt;!&ndash;                                    Για την πληροφόρησή σας για παλαιές καταστάσεις πληρωμών που αφορούν παλαιές διανομές μέχρι το Ακαδημαϊκό έτος 2015-16 παρακαλείσθε όπως απευθυνθείτε στο Γραφείο Αρωγής Χρηστών της υπηρεσίας μας.&ndash;&gt;-->
                        <!--&lt;!&ndash;                                    </p>&ndash;&gt;-->
                        <!--                                    <v-row>-->
                        <!--                                        <v-col>-->
                        <!--                                            <v-tooltip bottom>-->
                        <!--                                                <template v-slot:activator="{ on }">-->
                        <!--                                                    <v-btn style="color: aliceblue" color="#0c6170" block v-on="on" @click="goToTheSystem">Μετάβαση στο Σύστημα</v-btn>-->
                        <!--                                                </template>-->
                        <!--                                                <span>Μετάβαση στο Σύστημα Πληρωμών διανομών μέχρι 2015</span>-->
                        <!--                                            </v-tooltip>-->
                        <!--                                        </v-col>-->
                        <!--                                    </v-row>-->
                        <!--                                </v-card>-->
                        <!--                            </v-col>-->
                        <!--                        </v-row>-->

                        <v-row>
                            <v-col class="mx-5">
                                <v-card class="elevation-0" overlined>
                                    <p class="subtitle-1 text--primary ml-3">
                                        Σύστημα Πληρωμών για τις διανομές για το Ακαδημαϊκό Έτος 2016 - 17 και ύστερα</p>
                                    <v-divider></v-divider>

                                    <p class="subtitle-2 text--primary ml-3 mt-5">
                                        Για την διαχείριση των καταστάσεων πληρωμών που αφορούν σε διανομές του ακαδημαϊκού έτους
                                        2016-17 και μετά, πατήστε το κουμπί για να οδηγηθείτε στο σύστημα πληρωμών:</p>

                                    <v-row>
                                        <v-col>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn color="primary" block v-on="on" @click="goToTheCurrentSystem">Μετάβαση στο τρέχον Σύστημα</v-btn>
                                                </template>
                                                <span>Μετάβαση στο τρέχον Σύστημα Πληρωμών διανομών</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>

                                </v-card>
                            </v-col>
                        </v-row>

                    </v-card>
                </v-col>

                <v-col>
                    <v-card style=" max-height: 500px; overflow: auto">
                        <v-card-text>
                            <p class="title text--primary ml-3">
                                Πληροφορίες για τις Πληρωμές</p>
                        </v-card-text>

                        <vue-editor disabled="true"
                                :editor-toolbar="customToolbar"
                                v-model="infoText">
                        </vue-editor>
<!--                        <p class="ma-2" v-html="infoText" aria-readonly="true"></p>-->
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
</template>

<script>
	import requests from "../../requests";
	import { VueEditor } from "vue2-editor";
	export default {
		name: "Payments",
        components: {VueEditor},
		data: () => ({
			customToolbar:[
				[],
				[], // toggled buttons
				[
				],
				// ["blockquote", "code-block"],
				[],
				// [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
				[], // dropdown with defaults from theme
				[],
				[] // remove formatting button
			],
			infoText:'',
		}),

		methods: {

			//    @ click go to the system payment
			goToTheSystem() {
				/* * * * * * * TEST * * * * * * * *
                * next line is for testing locally*/
				if (window.location.href.indexOf('https://test.eudoxus.gr/') !== -1 || window.location.href.indexOf('localhost:') !== -1) {
					//if (window.location.href.indexOf('https://test.eudoxus.gr/') !== -1 ) {
					var url = 'https://payments.eudoxus.gr/sandbox/trunk/public_html/osy_publishers/?page=catalog';
				}
				else {
					var url = 'https://payments.eudoxus.gr/';
				}
				window.open(url,'_blank');
			},

			//    go to the current System
			goToTheCurrentSystem() {
				if (window.location.href.indexOf('https://test.eudoxus.gr/') !== -1) {
					var url = 'https://eudoxusosy.pilotiko.gr:9000/';
				}
				else {
					var url = 'https://osy-payments.eudoxus.gr/';
				}
				window.open(url,'_blank');
			}

		},

		created() {
			this.$store.commit('setLoadingModal', true);
			window.scrollTo(0, 0);
			requests.get('rest/pricing/info-text',(resp)=>{
				this.infoText = resp.text;
				this.$store.commit('setLoadingModal', false);
			});

		}
	}
</script>

<style scoped>

</style>